import { api } from '../../../helpers'
import { appConstants } from '../../../constants'

export const fetchDetailArticle = (id) => {
  return dispatch => {
    dispatch(loadDetailArticleRequest())
    api.get(`web/article/${id}`)
      .then((res) => {
        const { data: detailArticle, success, message } = res.data
        if (success === true) {
          dispatch(loadDetailArticleSuccess(detailArticle))
        } else {
          dispatch(loadDetailArticleFailed(message))
        }
      })
      .catch((message) => loadDetailArticleFailed(message))
  }
}

const loadDetailArticleRequest = () => ({
  type: appConstants.DETAIL_ARTICLE_REQUEST
})

const loadDetailArticleSuccess = (detailArticle) => ({
  type: appConstants.DETAIL_ARTICLE_SUCCESS,
  payload: { detailArticle }
})

const loadDetailArticleFailed = (message) => ({
  type: appConstants.DETAIL_ARTICLE_FAILED,
  payload: { message }
})
